import http from '../plugins/axios'

export const getAllCategoryRules = async (params) => {
    try {
        const response = await http.get('/api/v2/category-rules', { params })
        return response.data
    } catch (error) {
        throw error
    }
}

export const getDetailCategoryRule = async (id, params) => {
    try {
        const response = await http.get(`/api/v2/category-rules/${id}`, { params })
        return response.data
    } catch (error) {
        throw error
    }
}

export const createCategoryRule = async (payload) => {
    try {
        const response = await http.post('/api/v2/category-rules', payload)
        return response.data
    } catch (error) {
        throw error
    }
}

export const updateCategoryRule = async (id, payload) => {
    try {
        const response = await http.put(`/api/v2/category-rules/${id}`, payload)
        return response.data
    } catch (error) {
        throw error
    }
}

export const deleteCategoryRule = async (id) => {
    try {
        const response = await http.delete(`/api/v2/category-rules/${id}`)
        return response.data
    } catch (error) {
        throw error
    }
}
